export function useColumns(columns) {
    const visible = columns.filter((col) => col.hidden !== true);
    const pinnedLeft = visible.filter((col) => col.pinned === 'left');
    const pinnedRight = visible.filter((col) => col.pinned === 'right');
    const notPinned = visible.filter((col) => col.pinned === 'none' || !col.pinned);
    return {
        visible: [...pinnedLeft, ...notPinned, ...pinnedRight],
        pinnedLeft,
        pinnedRight,
    };
}
//# sourceMappingURL=useColumns.js.map